<template>
  <span>
    <!-- Innovadis custom: sanitize footer external URL before binding to href -->
    <a v-if="isExternalLink" class="footer-link" target="_blank" :href="getSafeUrl(to as string)">
      {{ title }}
    </a>

    <router-link v-else class="footer-link" active-class="footer-link--active" :to="to || '#'">
      <slot>{{ title }}</slot>
    </router-link>
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { getLinkAttr } from "@/core/utilities/common";
import { getSafeUrl } from "@/core/utilities/url/safeUrl";
import type { RouteLocationRaw } from "vue-router";

interface IProps {
  to?: RouteLocationRaw;
  title?: string;
}

const props = defineProps<IProps>();

const isExternalLink = computed(() => {
  return "externalLink" in getLinkAttr(props.to);
});
</script>

<style lang="scss">
.footer-link {
  @apply block text-base text-[--footer-top-link-color] truncate;

  &:hover {
    @apply text-[--footer-top-link-hover-color];
  }

  &--active {
    @apply text-[--footer-top-link-active-color];
  }
}
</style>
